import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook_reverse",
  "use": "facebook_reverse-usage",
  "viewBox": "0 0 10 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 18\" id=\"facebook_reverse\"><path d=\"M6.067 18V9.79h2.756l.413-3.2H6.067V4.545c0-.926.258-1.557 1.586-1.557l1.695-.001V.126A22.71 22.71 0 006.878 0C4.437 0 2.764 1.491 2.764 4.23v2.36H0v3.2h2.763V18h3.304z\" fill=\"#FFF\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol